import { createAction } from 'typesafe-actions';
import { ThemeModes } from 'themes/enums';

export type SetThemeModePayload = {
  mode: ThemeModes;
};

export const setThemeMode =
  createAction('app/setThemeMode')<SetThemeModePayload>();
